const getCodeFromError = error => {
  const { response = {} } = error;
  const { data = {} } = response;
  const { code = '' } = data;

  return code;
};

export default getCodeFromError;
